import { useEffect, useState } from 'react';
import { GameCard } from './GameCard';
import { useTheme } from '@src/theme/useTheme';
import { ThemeContext } from '@src/theme/ThemeContext';
import { loadSeason } from '@src/theme/registry';
import type { SeasonPackage } from '@src/theme/types';
import type { ComponentProps } from 'react';

export function ThemedGameCard(props: ComponentProps<typeof GameCard>) {
  const context = useTheme();
  const season = props.season || 'halloween';
  const [pkg, setPkg] = useState<SeasonPackage | null>(null);
  useEffect(() => {
    let active = true;
    void loadSeason(season)
      .then((value) => {
        if (active) setPkg(value);
      })
      .catch(() => {
        /* Keep the available artwork if loading fails. */
      });
    return () => {
      active = false;
    };
  }, [season]);
  return (
    <ThemeContext.Provider
      value={{ ...context, season, seasonPackage: pkg || context.seasonPackage }}
    >
      <GameCard {...props} />
    </ThemeContext.Provider>
  );
}

